// extracted by mini-css-extract-plugin
module.exports = {"container":"e_kB","widget":"e_lB","title":"e_mB","msrp":"e_nB","separator":"e_oB","textBadge":"e_pB"};